import { Box, Stack } from '@dtx-company/design-system/src'
import { COMPARE_ALL_PLANS_TILE_CONFIG, PLANS_UPGRADE_DIALOG_CONFIG } from '../constants'
import { FC } from 'react'
import { Grid } from '@mui/material'
import { PlanLabel } from '../types'
import { PlanTile } from './PlanTile'
import { useTileGraphicsByScreenSize } from '../utils/utils'

export const PlansUpgradeContainer: FC = () => {
  const tileGraphics = useTileGraphicsByScreenSize()
  return (
    <Stack direction="row" sx={{ justifyContent: 'center' }}>
      <Box
        sx={theme => ({
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          width: '100%',
          justifyContent: 'center',
          maxWidth: theme.spacing(316)
        })}
      >
        <Box
          sx={theme => ({
            display: { xs: 'grid', md: 'none' },
            p: theme.spacing(6),
            gap: 4,
            gridTemplateColumns: { xs: '1fr', lg: '1fr' },
            borderStyle: 'solid',
            borderColor: 'border.divider',
            borderWidth: theme.spacing(0, 0, 0.25, 0),
            a: { width: '100%' }
          })}
        >
          <PlanTile
            {...COMPARE_ALL_PLANS_TILE_CONFIG}
            planImageSrc={tileGraphics[PlanLabel.COMPARE]}
          />
        </Box>
        <Box
          sx={theme => ({
            display: 'flex',
            width: { xs: '100%', md: '50%', lg: '75%' },
            p: { xs: theme.spacing(6), md: theme.spacing(10, 6, 10, 10), lg: theme.spacing(10) }
          })}
        >
          <Grid
            container
            columnSpacing={{ xs: 1, sm: 6, lg: 6 }}
            rowSpacing={{ xs: 6, sm: 6, md: 6, lg: 0 }}
            columns={{ xs: 1, sm: 3, md: 1, lg: 3 }}
          >
            {PLANS_UPGRADE_DIALOG_CONFIG.map((plan, idx) => (
              <Grid item xs={1} sm={1} md={1} lg={1} key={`plan-upgrade-tile${idx}`}>
                <PlanTile {...plan} planImageSrc={tileGraphics[plan.planName]} />
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box
          sx={theme => ({
            display: { xs: 'none', md: 'grid' },
            p: { xs: theme.spacing(6), md: theme.spacing(10) },
            borderStyle: 'solid',
            borderColor: 'border.divider',
            borderWidth: theme.spacing(0, 0, 0, 0.25),
            gridTemplateColumns: { xs: '1fr', lg: '1fr' },
            maxWidth: { xs: '100%', md: '50%', lg: theme.spacing(70) },
            gap: 4
          })}
        >
          <PlanTile
            {...COMPARE_ALL_PLANS_TILE_CONFIG}
            planImageSrc={tileGraphics[PlanLabel.COMPARE]}
          />
        </Box>
      </Box>
    </Stack>
  )
}
